import React from "react";
import { components, GroupBase, MultiValueGenericProps } from "react-select";
import ClassificationIcon from "../../../../../../components/ClassificationIcon";
import { MenuItem } from "../../../../../../components/@types";

const { MultiValueContainer } = components;

function CustomMultiValueContainer<
  Option extends MenuItem,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: MultiValueGenericProps<Option, IsMulti, Group>) {
  const { testIdKey } = props.selectProps ?? {};

  return (
    <div
      className={"multiselect-value"}
      data-testid={`${testIdKey}_field_${props.data.value}`}
      title={props.data.label}
    >
      <MultiValueContainer {...props}>{props.children}</MultiValueContainer>
    </div>
  );
}

const CustomClassificationMultiValueContainer = (
  props: MultiValueGenericProps<MenuItem, true>
) => {
  const { testIdKey } = props.selectProps ?? {};

  return (
    <div
      className={"multiselect-value"}
      data-testid={`${testIdKey}_field_${props.data.value}`}
      title={props.data.label}
    >
      <MultiValueContainer {...props}>
        <ClassificationIcon
          classification={props.data.value}
          classificationStyle={{
            paddingRight: "10px",
            margin: "auto",
            marginLeft: "3px"
          }}
        />
        {props.children}
      </MultiValueContainer>
    </div>
  );
};

export { CustomMultiValueContainer, CustomClassificationMultiValueContainer };
